import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import About from './components/About';
import ConfirmationPage from './components/ConfirmationPage';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './components/Home';
import Services from './components/Services';
import theme from './styles/theme';

const Elements = ({children}) => (
  <Box  
  sx={{
    minHeight: '100vh', // Ensures it covers the full viewport height
    display: 'flex',
    flexDirection: 'column',
  }}
>
    <Header />
   {children}
    <Footer />
  </Box>
);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
    <Router>
      <Routes>
        <Route path="/" element={<Elements>
          <Home />
          <About />
          <Services />
          <ContactForm />
        </Elements>} />
        <Route path="/confirmation" element={<Elements>
          <ConfirmationPage />
        </Elements> } />
      </Routes>
    </Router>
    </ThemeProvider>
  );
};


export default App;